const state = {
  initial: null,
  isLogin: null,
  isLoading: 0,
  isSubLoading: 0,
  isDialogLoading: 0,
  isUploading: undefined,
  modal: {
    action: null,
    type: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    autoHeight: null,
    closeButton: true,
    customStyles: {}
  },
  modal2: {
    action: null,
    type: null,
    param: null,
    callback: null,
    height: null,
    width: null,
    autoHeight: null,
    closeButton: true,
    customStyles: {}
  },
  toast: null,
  borCor: null,
  unloadAlert: 0,
  scrollState: {
    top: null,
    height: null
  },
  afkCountDown: {
    value: null,
    default: 30 * 60 * 1000,
    interval: 1000,
    active: true
  },
  // const
  normalPage: [
    'main',
    'inherinext',
    'introduction',
    'seminar'
  ],
  userPage: [
  ],
  adminPage: [
  ]
}

const getters = {
  initial: state => state.initial,
  isLogin: state => state.isLogin,
  isLoading: state => state.isLoading > 0,
  isSubLoading: state => state.isSubLoading > 0,
  isDialogLoading: state => state.isDialogLoading > 0,
  isUploading: state => state.isUploading,
  modal: state => state.modal,
  modal2: state => state.modal2,
  toast: state => state.toast,
  borCor: state => state.borCor,
  unloadAlert: state => state.unloadAlert,
  scrollState: state => state.scrollState,
  afkCountDown: state => state.afkCountDown,
  // const
  normalPage: state => state.normalPage,
  userPage: state => state.userPage,
  adminPage: state => state.adminPage
}

const types = {
  appInitial: 'app/appInitial',
  setLogin: 'app/setLogin',
  setLoading: 'app/setLoading',
  clearLoading: 'app/clearLoading',
  setSubLoading: 'app/setSubLoading',
  clearSubLoading: 'app/clearSubLoading',
  setDialogLoading: 'app/setDialogLoading',
  clearDialogLoading: 'app/clearDialogLoading',
  setUploading: 'app/setUploading',
  setModal: 'app/setModal',
  setModal2: 'app/setModal2',
  addToast: 'app/addToast',
  setBorCor: 'app/setBorCor',
  setUnloadAlert: 'app/setUnloadAlert',
  setScrollState: 'app/setScrollState',
  setAFKCountDown: 'app/setAFKCountDown'
}

const mutations = {
  [types.appInitial] (state, boolean) {
    state.initial = boolean
  },
  [types.setLogin] (state, boolean) {
    state.isLogin = boolean
  },
  [types.setLoading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isLoading += 1
      } else {
        state.isLoading -= 1
      }
    }
  },
  [types.clearLoading] (state) {
    state.isLoading = 0
  },
  [types.setSubLoading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isSubLoading += 1
      } else {
        state.isSubLoading -= 1
      }
    }
  },
  [types.clearSubLoading] (state) {
    state.isSubLoading = 0
  },
  [types.setDialogLoading] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.isDialogLoading += 1
      } else {
        state.isDialogLoading -= 1
      }
    }
  },
  [types.clearDialogLoading] (state) {
    state.isDialogLoading = 0
  },
  [types.setUploading] (state, content) {
    state.isUploading = content
  },
  [types.setModal] (state, object) {
    state.modal = object
  },
  [types.setModal2] (state, object) {
    state.modal2 = object
  },
  [types.addToast] (state, object) {
    state.toast = { ...object }
  },
  [types.setBorCor] (state, object) {
    state.borCor = object
  },
  [types.setUnloadAlert] (state, boolean) {
    if (boolean !== undefined) {
      if (boolean) {
        state.unloadAlert += 1
      } else {
        state.unloadAlert -= 1
      }
    } else {
      state.unloadAlert = 0
    }
  },
  [types.setScrollState] (state, object) {
    state.scrollState = object
  },
  [types.setAFKCountDown] (state, object) {
    state.afkCountDown = {
      ...state.afkCountDown,
      ...object
    }
  }
}

const actions = {
  appInitialAction ({commit}, boolean) {
    commit(types.appInitial, boolean)
  },
  setLoginAction ({commit}, boolean) {
    commit(types.setLogin, boolean)
  },
  setLoadingAction ({commit}, boolean) {
    commit(types.setLoading, boolean)
  },
  clearLoadingAction ({commit}) {
    commit(types.clearLoading)
  },
  setSubLoadingAction ({commit}, boolean) {
    commit(types.setSubLoading, boolean)
  },
  clearSubLoadingAction ({commit}) {
    commit(types.clearSubLoading)
  },
  setDialogLoadingAction ({commit}, boolean) {
    commit(types.setDialogLoading, boolean)
  },
  clearDialogLoadingAction ({commit}) {
    commit(types.clearDialogLoading)
  },
  setUploadingAction ({commit}, content) {
    commit(types.setUploading, content)
  },
  setModalAction ({commit}, object) {
    commit(types.setModal, object)
  },
  setModal2Action ({commit}, string) {
    commit(types.setModal2, string)
  },
  addToastAction ({commit}, object) {
    commit(types.addToast, object)
  },
  setBorCorAction ({commit}, object) {
    commit(types.setBorCor, object)
  },
  setUnloadAlertAction ({commit}, boolean) {
    commit(types.setUnloadAlert, boolean)
  },
  setScrollStateAction ({commit}, object) {
    commit(types.setScrollState, object)
  },
  setAFKCountDownAction ({commit}, object) {
    commit(types.setAFKCountDown, object)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js